// extracted by mini-css-extract-plugin
export default {"root":"IconCategoryBoat_root__pk34X"};